import { AuthApiService } from '@revenuewell/logic-http';
import { NavigationService } from '@revenuewell/logic-navigation';
import { OidcService } from '@revenuewell/logic-oidc';
import { MilaCase, PatientCase } from './types';

export default class MilaService extends AuthApiService {
  private static instance: MilaService;

  private configUrl: string;

  private constructor(config: any, oidcService: OidcService) {
    super(oidcService, new NavigationService());
    this.configUrl = config.mila?.apiUrl;

    return this;
  }

  public static getInstance(config: any, oidcService: OidcService) {
    if (!MilaService.instance) {
      MilaService.instance = new MilaService(config, oidcService);
    }

    return MilaService.instance;
  }

  getMilaCase = async (locationId: number, caseId: string): Promise<MilaCase> => {
    const url = `${this.configUrl}/locations/${locationId}/mila/cases/${caseId}`;
    const response = await this.authFetch(url, { method: 'GET' });

    return response.json();
  };

  getPatientCases = async (
    locationId: number,
    patientId: number,
    params?: {
      timeStart?: string;
      timeEnd?: string;
      order?: 'ASC' | 'DESC';
      page?: number;
      pageSize?: number;
    }
  ): Promise<PatientCase[]> => {
    const url = new URL(`${this.configUrl}/locations/${locationId}/patient/${patientId}/mila/cases`);

    if (params) {
      Object.entries(params).forEach(([key, value]) => {
        if (value !== undefined) {
          url.searchParams.append(key, value.toString());
        }
      });
    }

    const response = await this.authFetch(url.toString(), { method: 'GET' });

    return response.json();
  };
}
